export default "__VITE_ASSET__Ay3wGzLk__"